import type { LiabilityFormLayout } from "../types";

export const liabilityIssueDateLayout = (): LiabilityFormLayout => {
  return {
    render: 'issueDate'
  }
}
